/**
 * Shared menu-item schedule helper — returns true when a scheduled item is
 * currently within its available day/time window (items without a schedule
 * are always active). Extracted so Cashier and Waiter share identical logic.
 */
export const isItemScheduleActive = (item) => {
  if (!item?.schedule?.enabled) return true;
  const now = new Date();
  const dayOfWeek = now.getDay();
  if (!(item.schedule.available_days || []).includes(dayOfWeek)) return false;
  const timeStr = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  const start = item.schedule.start_time || '00:00';
  const end = item.schedule.end_time || '23:59';
  return timeStr >= start && timeStr <= end;
};

export default isItemScheduleActive;
